import React from 'react';
import Proptypes from 'prop-types';
import { ImageCardContainer, ImageCardFooter, ImageContainer } from './index.style';
import Typography from '../../../../atoms/Typography';

export const PhotoCardCarouselElementFullView = ({
  image,
  onClick,
  label,
  hasFullView,
}) => (
  <ImageCardContainer onClick={onClick} hasFullView={hasFullView}>
    <ImageContainer image={image} hasFullView={hasFullView} />
    <ImageCardFooter>
      <Typography
        tag="p"
        type={Typography.TYPES.CAPTION}
        style={Typography.STYLES.ALT}
      >
        {label}
      </Typography>
    </ImageCardFooter>
  </ImageCardContainer>
);

PhotoCardCarouselElementFullView.defaultProps = {
  onClick: () => null,
  hasFullView: false,
};

PhotoCardCarouselElementFullView.propTypes = {
  image: Proptypes.oneOfType([Proptypes.string, Proptypes.node]).isRequired,
  onClick: Proptypes.func,
  label: Proptypes.string.isRequired,
  hasFullView: Proptypes.bool,
};

export default PhotoCardCarouselElementFullView;
